import Promotion253D3Container from "@/containers/Promotion/Promotion253D3Container";

export default function Promotion253D3() {
  return <Promotion253D3Container />;
}
